module.exports = __webpack_public_path__ + "static/img/banner2.d5ac664.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/banner2.jpg
// module id = dhh8
// module chunks = 41